import React from 'react';
import PropTypes from 'prop-types';
import {
  titleUI,
  currentOrPastDateUI,
  dateUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from '@department-of-veterans-affairs/platform-forms-system/validation';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import { isServingComponent } from '../../utils/pageDependencies';
import {
  validateAge,
  validateExitDateWithin180Days,
} from '../../../shared/utils/dates';

const { serviceInformation } = fullSchema.properties;

// rewrite validation of date range as default validation uses `to` and `from`
// instead of entryDate and exitDate
const validateServicePeriodRange = (
  errors,
  serviceDates,
  formData,
  schema,
  errorMessages,
) =>
  validateDateRange(
    { to: errors.exitDate },
    { from: serviceDates.entryDate, to: serviceDates.exitDate },
    formData,
    schema,
    errorMessages,
    true,
  );

export const ServiceDatesAlert = ({ formData }) =>
  isServingComponent(formData) ? (
    <va-alert status="info" uswds visible>
      <h3 slot="headline">Reserves or National Guard dates</h3>
      <p className="vads-u-margin-y--0">
        If you’ve served or are currently activated in the Reserves or National
        Guard, we’ll ask you for your activation dates and obligation term of
        service dates later in this form.
      </p>
    </va-alert>
  ) : null;
ServiceDatesAlert.propTypes = {
  formData: PropTypes.object,
};

const uiSchema = {
  'ui:description': ServiceDatesAlert,
  'view:mostRecentServiceDatesTitle': {
    ...titleUI('Most recent active service dates'),
  },
  serviceInformation: {
    'ui:validations': [validateServicePeriodRange],
    entryDate: currentOrPastDateUI({
      title: 'Most recent active service start date',
      dataDogHidden: true,
      monthSelect: false,
      validations: [validateAge],
    }),
    exitDate: dateUI({
      title: 'Most recent active service end date',
      allowedDates: 'any',
      dataDogHidden: true,
      monthSelect: false,
      validations: [validateExitDateWithin180Days],
      errorMessages: {
        pattern: 'Provide a valid date',
        required: 'Enter a date',
      },
    }),
    'view:serviceDetails': {
      'ui:description': () => (
        <va-details label="Where to find your service end date">
          The active service end date is also known as “separation date.” You
          can find it in your DD214.
        </va-details>
      ),
    },
  },
};

const schema = {
  type: 'object',
  required: ['serviceInformation'],
  properties: {
    'view:mostRecentServiceDatesTitle': {
      type: 'object',
      properties: {},
    },
    serviceInformation: {
      type: 'object',
      required: ['entryDate', 'exitDate'],
      properties: {
        entryDate: serviceInformation.properties.entryDate,
        exitDate: serviceInformation.properties.exitDate,
        'view:serviceDetails': {
          type: 'object',
          properties: {},
        },
      },
    },
  },
};

export default {
  uiSchema,
  schema,
  CustomPage: null,
};
